import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'

/**
 * 加载设备工单列表
 * @param params
 */
export function getOrderPage(params) {
    return request({
        url: envInfo.bgApp.orderPath + '/tenant/orderFill/conditionalQuery',
        method: 'get',
        params
    })
}
/**
 * 加载公司列表
 * @param params
 */
export function getCompanyList(params) {
    return request({
        url: envInfo.bgApp.organizationPath + '/tenant/company/list',
        method: 'get',
        params
    })
}
/**
 * 根据公司id加载项目
 * @param params
 */
export function getProjectList(params) {
    return request({
        url: envInfo.bgApp.basePath + `/tenant/project/list`,
        method: 'get',
        params
    })
}
/**
 * 根据公司id加载责任部门
 * @param params
 */
export function getResDeptName(params) {
    return request({
        url: envInfo.bgApp.organizationPath + `/tenant/dept/list`,
        method: 'get',
        params
    })
}
/**
 * 加载人员
 * @param params
 */
export function getEmployeeList(params) {
    return request({
        url: envInfo.bgApp.organizationPath + `/tenant/employee/empList`,
        method: 'get',
        params
    })
}
/**
 * 根据工单id查询所有信息
 * @param params
 */
export function getOrderDetail(params) {
    return request({
        url: envInfo.bgApp.orderPath + `/tenant/orderFill/getDetails`,
        method: 'get',
        params
    })
}
/**
 * 获取所在位置
 *
 */
export function getPosition() {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/position/tree',
        method: 'get',
    })
}

/**
 * 导出工单查询
 * @param params
 */
export function exportOrder(params) {
    return request({
        url: envInfo.bgApp.orderPath + '/tenant/orderFill/export',
        method: 'get',
        params
    })
}
